import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import VersionHistoryItemBase, {
  VersionHistoryItemAvatar,
} from 'notebook/version-history/VersionHistoryItemBase';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import getTestTimestampProps from 'test/lib/cypress/getTestTimestampProps';
import {HasAvatar} from 'ui-library/avatar/Avatar';
import {readableTime} from 'util/DateUtil';

export const VERSION_HISTORY_ITEM_FIRST_OPTION = 'Reset to version';
export const VERSION_HISTORY_ITEM_SECOND_OPTION = 'Duplicate from version';

export interface VersionHistoryItemProps {
  versionDatetime: string;
  versionCreator: HasAvatar;
  isSelected: boolean;
  onClick?: () => void;
  resetToVersionOnClick?: () => void;
  duplicateFromVersionOnClick?: () => void;
  oauth2ClientId?: string;
  oauth2ClientName?: string;
}

function VersionHistoryItem({
  versionDatetime,
  versionCreator,
  isSelected,
  onClick,
  resetToVersionOnClick,
  duplicateFromVersionOnClick,
  oauth2ClientId,
  oauth2ClientName,
}: VersionHistoryItemProps): JSX.Element {
  const firstRow = (
    <span
      className={css(styles.versionDatetime, isSelected && styles.versionDatetimeSelected)}
      {...getTestProps({component: 'VersionHistoryItem', element: 'versionTimestamp'})}
      {...getTestTimestampProps(versionDatetime)}
    >
      {readableTime(versionDatetime)}
    </span>
  );
  const secondRow = (
    <div {...getTestProps({component: 'VersionHistoryItem', element: 'versionAuthor'})}>
      <VersionHistoryItemAvatar
        user={versionCreator}
        tooltipText="Authored this version"
        oauth2ClientId={oauth2ClientId}
        oauth2ClientName={oauth2ClientName}
      />
    </div>
  );
  return (
    <VersionHistoryItemBase
      rows={[firstRow, secondRow]}
      isSelected={isSelected}
      onClick={onClick}
      firstOption={{
        text: VERSION_HISTORY_ITEM_FIRST_OPTION,
        icon: 'arrow-rotate-left',
        onClick: resetToVersionOnClick,
      }}
      secondOption={{
        text: VERSION_HISTORY_ITEM_SECOND_OPTION,
        icon: 'copy',
        onClick: duplicateFromVersionOnClick,
      }}
    />
  );
}

const styles = StyleSheet.create({
  versionDatetime: {
    fontSize: '13px',
    lineHeight: '16px',
    color: Color.GRAY_900,
  },
  versionDatetimeSelected: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
});

export default VersionHistoryItem;
